import React, { FC } from "react";
import { DataGrid } from "@mui/x-data-grid";
type DomainTableProps = {
    columns:Array<any>;
    rows:Array<any>;
};
const DomainTable: FC<DomainTableProps> = ({columns,rows}): JSX.Element => {
    
  return (
    <div className="mb-6">
      <DataGrid
        sx={{
          ".MuiDataGrid-columnHeader": {
            backgroundColor: "#E5E7EB"
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: "500",
            fontSize: 16,
            color: "#23304a"
          },
          ".MuiDataGrid-cell": {
            paddingLeft: {lg:20,xs:2,sm:4,md:10,xl:40},
            paddingY:2
          }
        }}
        getRowHeight={() => "auto"}
        rows={rows.map((self,index)=>({...self,id:index}))}

        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 }
          }
        }}
        pageSizeOptions={[5, 10]}
      />
    </div>
  );
};

export default DomainTable;
